var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-cascader',{staticStyle:{"width":"250px"},attrs:{"size":"small","options":_vm.options,"props":{ value: 'id', label: 'name', expandTrigger: 'hover', checkStrictly: true },"clearable":"","disabled":_vm.isDisabled},on:{"change":_vm.handleChange,"clean":_vm.handleChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f92fa650","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ChannelCascader.vue
// module id = 1225
// module chunks = 0